import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getApiObject } from '../../utils/api_list';
import BasicTable from './Table';

const getTableRows = (data) => {
  return data?.map(e => {
    return { name: e.val, desc: e.desc, isOptional: e.isOptional }
  })
}

function ApiDesc() {
  const { baseUrl, user } = useSelector((state) => state.queryParams);
  const { activeApi } = useSelector((state) => state.apiHelpSlice);
  const [apiObj, setAPIObj] = useState({});
  const [reqURL, setReqURL] = useState('');
  useEffect(() => {
    const obj = getApiObject(activeApi);
    // let url = `${baseUrl}/workbench?action=${activeApi}${obj?.params?.filter(e => e?.val === 'user')?.length ? '' : '&user=admin'}`;
    let url = `${baseUrl}/workbench?action=${activeApi}&user=${user}`;
    if ( obj.params && obj.params.length > 0) {
      obj?.params?.forEach((o) => {
        url += `&${o.val}=${o.sample}`;
      });
    }
    setReqURL(url);
    setAPIObj(obj);
  }, [baseUrl, activeApi])

  return (
    <Box sx={{ height: "90%",padding:0 }}>
        <div style={{ display: "flex", flexDirection: "column"}}>
          <Box id="desc">
            {" "}
            <p className="sectionHeading">Description</p> <p>{apiObj.desc}</p>{" "}
          </Box>
          <p className="sectionHeading">Request Url</p>
          <Box
            id="req-url"
            style={{
              backgroundColor: "#f2f2f2",
              borderRadius: ".5rem",
              padding: "10px",
              wordBreak: "break-all",
            }}>
            <p>{reqURL}</p>
          </Box>
        </div>
        <div>
          <Box id="req-parameters">
            <p id="params" className="sectionHeading">
              Query Parameters
            </p>
            <Box id="qTable" style={{paddingBottom:'50px'}}>
              <BasicTable rows={getTableRows(apiObj?.params || [])} />
            </Box>
          </Box>
        </div>
    </Box>
  );
}

export default ApiDesc